/* eslint-disable vue/no-unused-vars */
<template>
  <div>
    <a-card :loading="loading" style="margin-bottom:1rem" class="card">
      <div slot="title">
        <a-button
          @click="backButton()"
          type="primary"
          size="small"
          icon="left"
          shape="circle"
          class="back-button"
        />
        <router-link :to="`/payment-links/${this.paymentLink.id}/edit`">
          <span
            @click="handleEditSubscription()"
            class="hover-title main-card-title"
            >&nbsp;
            <a-icon type="link"></a-icon>
            {{ paymentLink.name }}
            <span style="font-size:1rem" class="title-id">
              #{{ paymentLink.id }}</span
            ></span
          >

          <span class="edit-icon"
            >&nbsp;&nbsp;<a-icon
              type="edit"
              style="font-size:18px; color: #aaa; "
            />
            Editar</span
          >
        </router-link>

        <!--<a-icon @click="backButton()" type="arrow-left">Volver </a-icon>-->
      </div>
      <!--
      <template class="ant-card-actions" slot="actions">
        <a-icon type="setting" />
        <a-icon type="edit" />
        <a-icon type="ellipsis" />
      </template>
      -->
      <a-switch
        slot="extra"
        style="margin-left:1em"
        checkedChildren="Activa"
        unCheckedChildren="Inactiva"
        defaultChecked
        disabled
      />
      <h3>
        <strong>Ventas:</strong>&nbsp;<a-icon type="user" />
        {{ paymentLink.salesCount }}
      </h3>
      <h3>
        <strong>Precio:</strong>
        {{
          new Intl.NumberFormat("es-AR", {
            style: "currency",
            currency: "ARS"
          }).format(paymentLink.amount)
        }}&nbsp;
        <a-tag
          color="green"
          style="font-size:13px; cursor:default"
          v-if="this.paymentLink.freeTrialDays == true"
          >{{ this.paymentLink.freeTrialDays }} días de prueba</a-tag
        >
      </h3>

      <h3>
        <strong>Total:</strong>&nbsp;
        {{
          new Intl.NumberFormat("es-AR", {
            style: "currency",
            currency: "ARS"
          }).format(paymentLink.totalSoldCurrentMonth)
        }}
        <span :class="$style.specificationText">
          {{
            new Intl.DateTimeFormat("es-AR", {
              month: "long"
            }).format(new Date())
          }}
        </span>
        /
        {{
          new Intl.NumberFormat("es-AR", {
            style: "currency",
            currency: "ARS"
          }).format(paymentLink.totalSold || 0)
        }}
        <span :class="$style.specificationText">
          total
        </span>
      </h3>
      <h3 style="font-size:13px; color:#aaa; margin-bottom:1rem">
        Creado el
        {{ paymentLink.createdAt | moment("DD/MM/YYYY") }}
        <a-tag
          style="font-size:13px; cursor:default"
          v-if="this.paymentLink.endDate != null"
        >
          Finaliza el {{ this.paymentLink.endDate | moment("DD/MM/YYYY") }}
        </a-tag>
      </h3>

      <router-link :to="`/payment-links/${this.paymentLink.id}/sell`">
        <a-button type="primary" size="small" style="padding-top:2px;">
          <!--<i class="icmn-user-plus" style="margin-right:0.5em" />-->Realizar
          Venta
        </a-button>
      </router-link>
      <router-link :to="`/payment-links/${this.paymentLink.id}/edit`">
        <a href="javascript: void(0);" class="btn btn-link btn-edit">
          <i class="icmn-cog mr-1" />
          Configuración
        </a>
      </router-link>
      <a-button
        type="primary"
        size="small"
        style="padding-top:1px; font-style:oblique"
        @click="handleLinkButton"
      >
        <i class="icmn-link" style="margin-right:0.5em" />Link de Pago
      </a-button>
    </a-card>

    <transactions-list
      v-if="!createRecord && paymentLinkIdLoaded"
      :showHeader="true"
      :paymentLinkId="paymentLink.id"
    ></transactions-list>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import PaymentLinks from "../List";
import Vue from "vue";
import utils from "@/services/utils";
import TransactionsList from "@/views/Dashboard/Transactions/TransactionsList";

export default {
  name: "paymentLinkDetails", //necesita tener un name para que funcione el <keep-alive>
  props: ["paymentLinkId"],
  components: {
    "transactions-list": TransactionsList
  },
  data() {
    return {
      loading: true,
      editIcon: false,
      paymentLink: {
        id: null,
        name: null,
        costCenter: {
          id: null,
          name: null,
          costCenterType: { name: null }
        },
        businessUnit: {
          id: null,
          name: null
        },
        dictionary: {
          costCenters: [
            {
              id: null,
              name: null,
              costCenterType: { name: null }
            }
          ],
          businessUnits: [
            {
              id: null,
              name: null
            }
          ]
        }
      },
      dateFormat: "DD/MM/YYYY",
      createRecord: false,
      editRecord: false,
      cascaderOptions: [
        {
          value: "tupaggo",
          label: "Tupaggo",
          isLeaf: false
        },
        {
          value: "harmony",
          label: "Harmony",
          isLeaf: false,
          children: [
            {
              value: "course",
              label: "Curso",
              isLeaf: false
            },
            {
              value: "event",
              label: "Evento",
              isLeaf: false
            }
          ]
        }
      ],
      options: [],
      paymentLinkIdLoaded: false
    };
  },
  methods: {
    ...mapActions({
      load: "paymentLinks/loadOne",
      generateLinkToken: "paymentLinks/generateLinkToken"
    }),
    backButton() {
      //this.$emit("backClick");
      this.$router.push(`/payment-links`);
    },
    async fetchRecord() {
      try {
        this.loading = true;
        const result = await this.load(this.$route.params.id);
        this.paymentLink = store.state.paymentLinks.record;
        this.paymentLinkIdLoaded = true;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    formatDate(date) {
      if (date) {
        const d = new Date(date);
        return d.toLocaleDateString();
      } else return null;
    },
    handleEditSubscription() {
      this.editRecord = true;

      //alert("hola");
    },
    onCascaderChange(value) {
      console.log(value);
    },
    async loadCascaderData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      let res, offset, limit, totalPages, options, tempOptions;
      try {
        if (targetOption.value == "tupaggo") {
          res = await Vue.prototype.$axios.get(`/admin/cost-centers`);
          if (res.data) {
            options = new Array();
            res.data.results.forEach(item => {
              options.push({
                label: `${item.costCenterType.name} - ${item.name}`,
                value: item.id.toString()
              });
            });
          }
        } else if (targetOption.value == "course") {
          offset = 1; //en harmony offset es el page
          limit = 100;
          totalPages = 1;
          tempOptions = new Array();

          Vue.prototype.$axiosHarmony.defaults.headers.common["Authorization"] =
            process.env.VUE_APP_HARMONY_COURSES_SEARCH_API_KEY;

          for (offset = 1; offset <= totalPages; offset++) {
            res = await Vue.prototype.$axiosHarmony.get(`/courses`, {
              params: {
                type: "country",
                country: "ar",
                language: "es-ar",
                limit,
                offset
              }
            });
            if (res.data) {
              res.data.courses.forEach(item => {
                if (!tempOptions[item.title])
                  tempOptions[item.title] = new Array();
                if (item.course_id.trim() != "") {
                  tempOptions[item.title].push({
                    label: `${item.title} - ${item.course_id}`,
                    value: item.course_id
                  });
                }
              });
              totalPages = Math.ceil(res.data.total / limit);
            }
          }
          options = new Array();
          for (var key in tempOptions) {
            tempOptions[key].sort((a, b) => {
              if (a.value < b.value) {
                return -1;
              } else return 1;
            });
            options = options.concat(tempOptions[key]);
          }
        } else if (targetOption.value == "event") {
          offset = 1;
          limit = 100;
          totalPages = 1;
          tempOptions = new Array();

          Vue.prototype.$axiosHarmony.defaults.headers.common["Authorization"] =
            process.env.VUE_APP_HARMONY_EVENTS_SEARCH_API_KEY;

          for (offset = 1; offset <= totalPages; offset++) {
            res = await Vue.prototype.$axiosHarmony.get(`/events`, {
              params: {
                type: "country",
                country: "ar",
                limit,
                offset
              }
            });
            if (res.data) {
              res.data.courses.forEach(item => {
                if (item.course_id.trim() != "") {
                  if (!tempOptions[item.title])
                    tempOptions[item.title] = new Array();
                  tempOptions[item.title].push({
                    label: `${item.title} - ${item.course_id}`,
                    value: item.course_id
                  });
                }
              });
              totalPages = Math.ceil(res.data.total / limit);
            }
          }
          options = new Array();
          for (var key2 in tempOptions) {
            tempOptions[key2].sort((a, b) => {
              if (a.value < b.value) {
                return -1;
              } else return 1;
            });
            options = options.concat(tempOptions[key2]);
          }
        }
        targetOption.children = options;
        this.cascaderOptions = [...this.cascaderOptions];
        targetOption.loading = false;
      } catch (error) {
        targetOption.loading = false;
        console.log(error);
        throw error;
      }
    },
    handleBusinessUnitChange() {},
    handleRoute() {
      if (this.$route.name == "paymentLinkDetails") this.fetchRecord();
      else if (this.$route.name == "paymentLinkDetailsAdd")
        this.createRecord = true;
      else if (this.$route.path.indexOf("/edit") > 0) {
        this.editRecord = true;
        this.fetchRecord();
      }
    },
    async handleLinkButton() {
      const linkToken = await this.generateLinkToken(this.$route.params.id);

      utils.copyToClipboard(
        `${process.env.VUE_APP_PAYMENT_BASE_URL}/${linkToken}`
      );
      this.$notification["success"]({
        message: "Link copiado.",
        description:
          "Para pegarlo tipea ctrl + v en el teclado o elije la opción 'Pegar' con el botón derecho del mouse."
      });
    }
  },
  mounted() {
    this.handleRoute();
  },
  watch: {
    //REACTIVE TO URL CHANGE
    $route(to) {
      this.handleRoute();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
</style>

<style lang="css">
.ant-card {
  border-radius: 7px;
}
.ant-card-head-title {
}
.ant-card-body {
  padding-bottom: 9px;
  padding: 17px 32px;
}
.ant-list-item-action {
  margin-top: 1rem;
}
.ant-dropdown-link {
  text-transform: none;
  font-weight: 400;
}
.ant-card-head {
  min-height: 44px;
}
.ant-card-head-wrapper {
  flex-direction: row;
}
.ant-card-extra,
.ant-card-head-title {
  padding-top: 13px;
  padding-bottom: 9px;
}
.ant-tag {
  vertical-align: middle;
}
h4:hover {
  color: #0190fe;
  cursor: pointer;
}
.anticon {
  vertical-align: -0.2rem;
}
.ant-tag {
  vertical-align: 0.2rem;
}

/*
.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow {
  left: 0;
  line-height: 0;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding-left: 20px;
}
.ant-btn-link {
  border: none;
}
*/
.back-button {
  /*background-color: #fff;
  border-color: #777;
  color: #777;*/
  vertical-align: 0.38rem;
}
/*
.back-button:hover {
  background-color: #0190fe;
  border-color: #0190fe;
  color: #fff;
}*/
.back-button .anticon {
  vertical-align: -0.213rem;
}
.ant-collapse-item {
  border-bottom: none !important;
}
/*
h3 {
  font-size: 1.2rem;
}
strong {
  font-weight: normal;
  color: black;
}*/
@media (max-width: 767px) {
  .ant-card-head-wrapper {
  }
  .ant-card-head-title {
    flex-grow: 5;
    /*font-size: 100%;*/
    width: 25rem;
  }
  .ant-card-extra {
    float: inherit !important;
    margin-left: 1rem !important;
    align-self: flex-end;
    vertical-align: middle;
    padding-bottom: 1.28rem;
  }
  .ant-switch {
    margin-left: 0 !important;
  }
  .title-id {
    display: none;
  }
  .hover-title {
    font-size: 1.7rem;
    letter-spacing: -1px;
  }
  .hover-title + .edit-icon {
    display: inline;
  }
  .edit-subscription-button {
    display: inline !important;
  }
  .edit-icon {
    display: none !important;
  }
}
.edit-icon {
  display: none;
  font-size: 13px;
  color: #aaa;
  vertical-align: -0rem;
}
.hover-title {
  cursor: pointer;
}
.hover-title:hover + .edit-icon {
  display: inline;
}
.btn-edit {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
